<template>

  <v-container fluid full-height>

    <v-navigation-drawer :app="true" :dark="true" width="250" :mini-variant.sync="$store.state.drawer">

      <v-list>

        <v-toolbar color="#424242" flat>
          <v-list>
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-avatar>
                  <img src="@/assets/logo.png">
                </v-avatar>
              </v-list-tile-avatar>
              <v-list-tile-title v-if="!$store.state.drawer"><p>Nigeria ICT Innovation</p></v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-toolbar>

        <v-divider></v-divider>

        <v-list-tile>
          <v-list-tile-avatar>
            <v-icon color="#009688">dashboard</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title><router-link to="/dashboard">Dashboard</router-link></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile>
          <v-list-tile-avatar>
            <v-icon color="#009688">book</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title><router-link to="/legislations">Legislations</router-link></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile>
          <v-list-tile-avatar>
            <v-icon color="#009688">people</v-icon>
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title><router-link to="/users">Users</router-link></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

      </v-list>

    </v-navigation-drawer>

    <router-view :ref="$route.fullPath"></router-view>

  </v-container>

</template>

<script>
  export default {
    name: "main",
    props: {
      mini: {
        type: Boolean,
        default: true
      }
    },
    methods: {
      logout() {
        this.$store.commit("logout");
        this.$router.replace("/");
      }
    }
  }
</script>

<style scoped>

  .v-list {
    padding: 0;
  }

  .container.fluid {
    padding: 0;
  }

  a {
    text-decoration:  none;
  }
</style>